import ProductCarousel from 'modules/productCarousel';
import ProductReviews from 'modules/productReviews';
import VideoModal from 'modules/VideoModal';
import ProductTestDrive from 'modules/productTestDrive';
import PersonalizeProduct from 'modules/productPersonalize';
import ProductCrossSells from 'modules/productCrossSells';
import ProductAttribute from 'modules/ProductAttribute';
import Modal from 'modules/Modal';
import HighlightCarousel from 'modules/highlightCarousel';
import ReviewList from 'modules/reviewList';
import ConfiguratorError from 'modules/configuratorError';
import ConfiguratorModal from 'modules/configuratorModal';

export default {
	init() {
		ConfiguratorModal.init();
		ConfiguratorError.init($('.js-configurator'), $('.js-configurator-error'));
		ReviewList.init($('.js-review-list'), $('.js-review-nav'));
		HighlightCarousel.init($('.js-highlight-carousel'));
		ProductCarousel.init($('.js-product-gallery'));
		ProductReviews.init($('.js-open-review'), $('#review-modal'), $('.js-review-form'));
		PersonalizeProduct.init($('.js-personalize-bike'), $('.js-configurator'));
		ProductTestDrive.init($('.js-request-test-drive'), $('#test-drive'));
		ProductCrossSells.init($('.js-cross-sell-info'), $('#cross-sells'));
		ProductAttribute.init($('.js-attribute-info'), $('#attribute-info'));
		VideoModal.init($('.js-play-video'), $('#product-video'));
		Modal.init($('.js-unavailable-info'), $('#out-of-stock'));
	}
};
